const safeLangCodes: Record<string, string> = {
  pt: 'pt-br',
  pt_br: 'pt-br',
  'pt-br': 'pt-br',

  en: 'en',
  en_us: 'en',
  'en-us': 'en',
  en_gb: 'en',
  'en-gb': 'en',

  es: 'es',
  es_es: 'es',
  'es-es': 'es'
}

export const getSafeLangCode = (langCode: string) => {
  const code = safeLangCodes[langCode.toLowerCase()]
  return code || safeLangCodes.pt
}
